const affirmationProgramEntitlementEnumerators = {
  source: ['Apple', 'Company', 'Google', 'Stripe', 'Roku'],
  renewalPeriod: ['Monthly', 'Annually'],
};

export default affirmationProgramEntitlementEnumerators;
